import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import IconDonLinear from "@/assets/icons/don-linear.svg?react";
import IconAdCircleOnLinear from "@/assets/icons/ad-circle-on-linear.svg?react";
import IconCoinsLinear from "@/assets/icons/coins-linear.svg?react";
import IconRocketLinear from "@/assets/icons/rocket-linear.svg?react";
import { useTranslation } from "react-i18next";
import BaseButton from "@/components/base/button/BaseButton.tsx";
import { useNavigate } from "react-router";
import { Fragment } from "react/jsx-runtime";
import { usePremiumInfos } from "@/pages/profile/api";
import { formatNumber } from "@/shared/utils";
import IconChevron from "@/assets/icons/chevron.svg?react";
import IconDiamondFilled from "@/assets/icons/diamond-filled-linear.svg?react";
import IconDiamond from "@/assets/icons/diamond-filled.svg?react";
import CloseIcon from "@/assets/icons/close.svg?react";
import TaskBaseButton from "@/components/base/button/TaskBaseButton";

interface ModalBuyPremiumProps {
  trigger?: React.ReactNode;
}

const ModalBuyPremium = ({ trigger }: ModalBuyPremiumProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: premium } = usePremiumInfos();

  const tasks = [
    { title: t("double_don"), Icon: IconDonLinear },
    { title: t("see_more_ads_and_get_more_don"), Icon: IconAdCircleOnLinear },
    { title: t("bonus_don"), Icon: IconCoinsLinear },
    { title: t("unlimited_challenges"), Icon: IconRocketLinear },
  ];


  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger ? (
          trigger
        ) : (
          <TaskBaseButton className="bg-yellow-linear text-black gap-1">
            {t("task_status.INCOMPLETE")}
            <IconDiamond />
          </TaskBaseButton>
        )}
      </DialogTrigger>
      <DialogContent
        className="common-dialog-content gap-2"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <img
          className="absolute left-1/2 -translate-x-1/2 top-0 -translate-y-1/2 w-[200px] aspect-square pointer-events-none z-10"
          src="images/patterns/check-in-modal.webp"
          alt=""
        />
        <DialogClose className="absolute top-4 right-4 z-10 size-[28px] bg-white/08 rounded-full flex items-center justify-center outline-none ring-0 shadow-none border-none">
          <CloseIcon className="size-4" />
        </DialogClose>

        <DialogHeader className="pt-[38px] flex items-center">
          <DialogTitle className="flex items-center mb-1 justify-center gap-1.5 text-[22px] text-white leading-130 font-bold">
            <IconDiamondFilled width="24" height="24" />
            {t("premium")}
          </DialogTitle>
        </DialogHeader>
        <p className="text-center mb-4 text-sm leading-130 text-white/80 font-normal">
          {t("modal_premium_description")}
        </p>
        <div className="flex bg-white/08 border-b border-white/08 rounded-2xl pl-3 flex-col overflow-hidden">
          {tasks.map(({ title, Icon }, index) => (
            <Fragment key={index}>
              <div className="flex items-center justify-start gap-2 py-2 relative group">
                <Icon width="24" height="24" />
                <div className="text-xs font-semibold leading-130 w-full pr-3">
                  {index === 2
                    ? t("bonus_don", {
                        value: formatNumber(premium?.[0].don_award ?? 25000),
                      })
                    : title}
                </div>
                {index < tasks.length - 1 && (
                  <hr className="border-none h-px w-full bg-white/08 absolute bottom-0 left-8" />
                )}
              </div>
            </Fragment>
          ))}
        </div>
        <DialogFooter className="w-full mt-3">
          <BaseButton
            className="w-full !text-dark"
            text={t("go_to_premium")}
            variant="premium"
            vibrate={true}
            vibrationType="soft"
            onClick={() => {
              navigate("/profile/premium");
            }}
            suffix={<IconChevron className="w-5 h-5" strokeWidth="1.5" />}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalBuyPremium;
